import React, { Component } from 'react';

class StatusControl extends Component {
    
    onStatusChange(index) {
        this.props.onChange(index);
    }

    render() {
        const { selectedStatus, options } = this.props;

        if (!options) {
            return null;
        }
        
        const status = options[selectedStatus];

        const optionViews = options.map((option, index) => {
            return (
                <div className="radio radio-green" onClick={() => this.onStatusChange(index)} key={index}>
                    <input type="radio" className="ip-active" checked={selectedStatus === index} onChange={() => { }} />
                    <label htmlFor="radio1">{option.title}</label>
                </div>
            );
        });

        return (
            <div className="active-choice">
                <div className="form-group radio-btn">
                    {optionViews}
                </div>
                <p className="active">{status ? status.desc : 'Unknown'}</p>
            </div>
        );
    }
}

export default StatusControl;



// WEBPACK FOOTER //
// ./src/components/StatusControl.jsx